/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { useQuery } from '@tanstack/react-query';

import { ApiError, GetAdminOauthClientResponse } from '@/client';
import { mgmtPlaneAPIClient } from '@/client/mgmtPlane';

export type UseM2MClientQueryParams = {
  clientId: string | undefined;
};

/**
 * Hook for fetching a single M2M client by ID.
 *
 * @param clientId - The ID of the M2M client to fetch
 *
 * @returns React Query result containing the M2M client data
 */
export function useM2MClientQuery({ clientId }: UseM2MClientQueryParams) {
  return useQuery<GetAdminOauthClientResponse, ApiError>({
    queryKey: ['m2mClient', clientId],
    queryFn: async () => {
      return mgmtPlaneAPIClient.adminOauthClients.getAdminOauthClient({
        clientId: clientId!,
      });
    },
    enabled: !!clientId,
  });
}
